import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink, BrowserRouter, useHistory } from "react-router-dom";
//import { browserHistory } from 'react-router'
import config from "../../config";
import { useParams } from "react-router";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import Select from "react-validation/build/select";
import CheckButton from "react-validation/build/button";
import { selectDistrict, selectState } from "../Actions/CommonAction";
import { addRecruiter, getCompanyList } from "../Actions/AdminAction";
import { token } from "../Actions/AuthAction";
import Loader from "../Common/Loader";
import ShowError from "../Common/Error";
import {
  emailvalid,
  phonevalid,
  pincodevalid,
  stringvalid,
} from "../Common/CommonValidation";
import Swal from "sweetalert2";
const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};
const Add = (props) => {
  const form = useRef();
  const checkBtn = useRef();

  const id = useParams().id;
  let detail = "";
  //console.log("finale", props.history.location.state.detail);
  if (id == 0) {
    detail = props.history.location.state.detail[0];
  } else {
    if (id) {
      detail = id != undefined ? props.location.state.detail : "";
    } else {
      detail = null;
    }
  }
  console.log("finale", detail);
  const [name, setName] = useState({
    value: detail ? detail.name : "",
    error: "",
    isRequired: true,
  });
  const [email, setEmail] = useState({
    value: detail ? detail.user.email : "",
    error: "",
    isRequired: true,
  });
  const [phone, setPhone] = useState({
    value: detail ? detail.user.phone : "",
    error: "",
    isRequired: true,
  });
  const [alternatephone, setAlternatephone] = useState({
    value: detail ? detail.alternatephone : "",
    error: "",
    isRequired: true,
  });
  const [location, setLocation] = useState({
    value: detail ? detail.address : "",
    error: "",
    isRequired: true,
  });
  const [pincode, setPincode] = useState({
    value: detail ? detail.pincode : "",
    error: "",
    isRequired: true,
  });
  const [postname, setPostname] = useState({
    value: detail ? detail.postname : "",
    error: "",
    isRequired: true,
  });
  const [picture, setPicture] = useState({
    value: "",
    error: "",
    isRequired: true,
  });

  const [showpicture, setShowPicture] = useState(
    detail ? config.IMAGE_URL + "/" + detail.logo : ""
  );
  const [stateList, setStateList] = useState({
    value: "",
    error: "",
    options: [],
    isRequired: true,
  });
  const [state, setState] = useState({
    value: detail ? detail.state.state_id : "",
    error: "",
    options: [],
    isRequired: true,
  });
  const [cityList, setCityList] = useState({
    value: "",
    error: "",
    options: [],
    isRequired: true,
  });
  const [city, setCity] = useState({
    value: detail ? detail.city.district_id : "",
    error: "",
    options: [],
    isRequired: true,
  });

  const [compnayList, setCompanyList] = useState({
    value: "",
    error: "",
    options: [],
    isRequired: true,
  });
  const [company, setCompany] = useState({
    value: detail ? detail.company.name : "",
    error: "",
    options: [],
    isRequired: true,
  });

  // const [lastname, setLastname] = useState({ value:  '', error: '', isRequired: true });
  // const [email, setEmail] = useState({ value:  '', error: '', isRequired: true });
  // const [mobileno, setMobileno] = useState({ value:  '', error: '', isRequired: true });
  // const [password, setPassword] = useState({ value:  '', error: '', isRequired: true });
  // const [confirmpassword, setConfirmassword] = useState({ value:  '', error: '', isRequired: true });
  // const [referalcode, setReferalcode] = useState({ value:  '', error: '', isRequired: true });

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(undefined);
  const [error, setError] = useState(undefined);
  const [setpasserror, setPassError] = useState(false);
  const [message, setMessage] = useState("");
  const [refresh, setRefresh] = useState(false);

  const pagepath = "/recruiteradd";
  let redirectpath = "";
  if (id == 0) {
    redirectpath = "/recruiterprofile";
  } else {
    redirectpath = "/recruiterlist";
  }

  let history = useHistory();

  useEffect(() => {
    selectState({ status: 1 }).then((res) => {
      setStateList({ ...stateList, options: res.data });
    });

    getCompanyList().then((res) => {
      setCompanyList({ ...compnayList, options: res.data });
    });
    if (detail && detail.state.state_id) {
      selectDistrict({ state_id: detail.state.state_id }).then((res) => {
        setState({ ...state, value: detail.state.state_id });
        setCityList({ ...cityList, options: res.data });
      });
    }
  }, []);

  const loadCity = (e) => {
    selectDistrict({ state_id: e }).then((res) => {
      setState({ ...state, value: e });
      setCityList({ ...cityList, options: res.data });
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    //localStorage.setItem("test", 'dfasdf');
    //alert(password);return false;

    setMessage("");
    setLoading(true);

    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      //         if(password.value != confirmpassword.value){
      //             setMessage("Please enter the match password");
      //             setLoading(false);
      //             return false;

      //         }

      addRecruiter({
        key: token(),
        id: id != undefined ? id : null,
        email: email.value,
        phone: phone.value,
        name: name.value,
        alternatephone: alternatephone.value,
        address: location.value,
        stateid: state.value,
        cityid: city.value,
        pincode: pincode.value,
        companyid: "1",
        postname: postname.value,
        logo: picture.value,
      }).then((res) => {
        //alert(res);
        if (res.status) {
          setError(res.message);
          setPassError(true);
          setLoading(false);
          setStatus(res.status);

          //history.push("/universityadd");
          //window.location.reload();
        } else {
          Swal.fire("Error", res.message, "error");

          setMessage(res.msg);
          setLoading(false);
          return false;
        }
      });
    } else {
      setLoading(false);
    }
  };

  const onChangePicture = (e) => {
    console.log("picture: ", picture);
    //alert(e.target.files[0])
    setShowPicture(URL.createObjectURL(e.target.files[0]));
    var reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    reader.onload = () => {
      console.log(reader.result);
      setPicture({ ...picture, value: reader.result });
    };
  };

  const onHideModal = () => {
    setError(undefined);
  };
  return (
    <>
      {loading && <Loader />}

      {error && (
        <ShowError
          datastatus={status}
          datapagepath={pagepath}
          dataredirectpath={redirectpath}
          message={error}
          passerror={setpasserror}
          toggleModal={onHideModal}
          datarefresh={refresh}
        />
      )}
      <div className="row mb-4">
        <div className="col-md-12">
          <h4 className="table_heading position-relative">
            RECRUITER {id == undefined ? "ADD" : "EDIT"}
          </h4>
        </div>
      </div>
      <div className="card formcard">
        <div className="card-body">
          <Form className="auth_form" ref={form}>
            <div className="row">
              <div className="form-group col-md-6">
                <label className="small mb-1" for="inputPassword">
                  Company Name
                  <span className="text-danger font-weight-bold">*</span>
                </label>
                <Select
                  disabled
                  class="form-control rounded-pill"
                  title="Select Company"
                  onChange={(e) => setCompany(e.target.value)}
                >
                  {compnayList.options !== undefined &&
                    compnayList.options.map((item) => (
                      <option value={item.id}>{item.name}</option>
                    ))}
                </Select>
              </div>

              <div className="form-group col-md-6">
                <label className="small mb-1" for="inputPassword">
                  Name
                  <span className="text-danger font-weight-bold">*</span>
                </label>
                <Input
                  type="text"
                  className="form-control py-4 rounded-pill"
                  placeholder="Enter Name"
                  name="name"
                  value={name.value}
                  onChange={(e) => setName({ ...name, value: e.target.value })}
                  validations={[required, stringvalid]}
                />
              </div>

              <div className="form-group col-md-6">
                <label className="small mb-1" for="inputPassword">
                  Email
                  <span className="text-danger font-weight-bold">*</span>
                </label>
                <Input
                  type="text"
                  className="form-control py-4 rounded-pill"
                  placeholder="Enter Email"
                  name="email"
                  value={email.value}
                  onChange={(e) =>
                    setEmail({ ...email, value: e.target.value })
                  }
                  validations={[required, emailvalid]}
                  disabled={id == undefined ? false : true}
                />
              </div>

              <div className="form-group col-md-6">
                <label className="small mb-1" for="inputPassword">
                  Phone
                  <span className="text-danger font-weight-bold">*</span>
                </label>
                <Input
                  type="text"
                  className="form-control py-4 rounded-pill"
                  placeholder="Enter Phone"
                  name="phone"
                  value={phone.value}
                  onChange={(e) =>
                    setPhone({ ...phone, value: e.target.value })
                  }
                  validations={[required, phonevalid]}
                  disabled={id == undefined ? false : true}
                  maxlength="10"
                />
              </div>

              <div className="form-group col-md-6">
                <label className="small mb-1" for="inputPassword">
                  Alternate Phone
                  <span className="text-danger font-weight-bold">*</span>
                </label>
                <Input
                  type="text"
                  className="form-control py-4 rounded-pill"
                  placeholder="Enter Alternate Phone"
                  name="alternatephone"
                  value={alternatephone.value}
                  onChange={(e) =>
                    setAlternatephone({
                      ...alternatephone,
                      value: e.target.value,
                    })
                  }
                  validations={[required, phonevalid]}
                  maxlength="10"
                />
              </div>

              <div className="form-group col-md-6">
                <label className="small mb-1" for="inputPassword">
                  Pincode
                  <span className="text-danger font-weight-bold">*</span>
                </label>
                <Input
                  type="text"
                  className="form-control py-4 rounded-pill"
                  placeholder="Enter Pincode"
                  name="pincode"
                  value={pincode.value}
                  onChange={(e) =>
                    setPincode({ ...pincode, value: e.target.value })
                  }
                  validations={[required, pincodevalid]}
                />
              </div>

              <div className="form-group col-md-6">
                <label className="small mb-1" for="inputPassword">
                  State
                  <span className="text-danger font-weight-bold">*</span>
                </label>
                <Select
                  validations={[required]}
                  class="form-control rounded-pill"
                  title="Select State"
                  onChange={(e) => loadCity(e.target.value)}
                  value={state.value}
                >
                  <option selected>Select State</option>
                  {stateList.options !== undefined &&
                    stateList.options.map((item) => (
                      <option value={item.state_id}>{item.name}</option>
                    ))}
                </Select>
              </div>

              <div className="form-group col-md-6">
                <label className="small mb-1" for="inputPassword">
                  City
                  <span className="text-danger font-weight-bold">*</span>
                </label>
                <Select
                  validations={[required]}
                  class="form-control rounded-pill"
                  title="Select State"
                  onChange={(e) => setCity({ ...city, value: e.target.value })}
                  value={city.value}
                >
                  <option selected>Select City</option>
                  {cityList.options !== undefined &&
                    cityList.options.map((item) => (
                      <option value={item.district_id}>{item.name}</option>
                    ))}
                </Select>
              </div>

              <div className="form-group col-md-6">
                <label className="small mb-1" for="inputPassword">
                  Location
                  <span className="text-danger font-weight-bold">*</span>
                </label>
                <Input
                  type="text"
                  className="form-control py-4 rounded-pill"
                  placeholder="Enter Location"
                  name="location"
                  value={location.value}
                  onChange={(e) =>
                    setLocation({ ...location, value: e.target.value })
                  }
                  validations={[required]}
                />
              </div>

              <div className="form-group col-md-6">
                <label className="small mb-1" for="inputPassword">
                  Post Name
                  <span className="text-danger font-weight-bold">*</span>
                </label>
                <Input
                  type="text"
                  className="form-control py-4 rounded-pill"
                  placeholder="Enter Post Name"
                  name="postname"
                  value={postname.value}
                  onChange={(e) =>
                    setPostname({ ...postname, value: e.target.value })
                  }
                  validations={[required]}
                />
              </div>

              <div className="form-group col-md-6">
                <label
                  className="small mb-1 d-flex justify-content-start"
                  for="inputPassword"
                >
                  Upload Logo
                  <span className="text-danger font-weight-bold">*</span>
                </label>

                <div className="d-flex justify-content-start">
                  <Input
                    type="file"
                    className="uploadfile"
                    placeholder="Enter Logo"
                    id="upload"
                    accept=".jpg,.jpeg,.png"
                    hidden
                    onChange={onChangePicture}
                    validations={showpicture == "" ? [required] : []}
                  />
                </div>
                <label for="upload" className="uploadfile">
                  <i className="fa fa-upload" aria-hidden="true"></i> Choose
                  file
                  <span className="text-danger font-weight-bold">*</span>
                </label>
                {showpicture && (
                  <div className="previewProfilePic">
                    <img
                      className="playerProfilePic_home_tile"
                      src={showpicture}
                      width="50px"
                      height="50px"
                    ></img>
                  </div>
                )}
              </div>

              <div className="form-group mt-4 mb-0">
                <button
                  onClick={handleSubmit}
                  className="btn btn-primary-custom mx-2"
                >
                  Submit
                </button>
                {loading && (
                  <span className="spinner-border spinner-border-sm"></span>
                )}
                {message && (
                  <div className="form-group">
                    <div className="alert alert-danger" role="alert">
                      {message}
                    </div>
                  </div>
                )}
                <CheckButton style={{ display: "none" }} ref={checkBtn} />
                <Link
                  className="btn btn-secondary-custom mx-2"
                  to="/recruiterlist"
                >
                  Cancel
                </Link>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default Add;
